import React from 'react';
import { Link } from 'gatsby';

import '../../styles/scss/style.scss';


export const Hero5 = () => {
  return (
          <div className="hero animated bounce" style={{ marginTop:"10rem" }}>
            <div className="feature__wrap">
              <div className="feature__left">
                <h3 className="feature__lead feature__lead--1 showcase__lead text-left">
                  Desktop and mobile versions of templates
                </h3>
                <p className="feature__text">
                    The desktop and mobile versions of different pages, templates and layouts is also made available in loop.
                    This enables you to see how they can look on different screens.
                </p>
              <br />
                    {/* <Link
                      className="btn1 btn__inverse"
                      to="#pricing"
                    >
                       Get Loop Pro X
                    </Link> */}
              </div>
              <div className="feature__right">
                <img
                  src={require('../../components/images/loopmobile.png')}
                  alt="#"
                  className="feature__img"
                  
                />
              </div>
            </div>

          </div>
  );
};
